import { Check } from "lucide-react";

const STEPS = [
  { key: "order_received", label: "Order Received" },
  { key: "photos_received", label: "Photos Received" },
  { key: "in_design", label: "In Design" },
  { key: "quality_review", label: "Quality Review" },
  { key: "ready", label: "Ready" },
  { key: "delivered", label: "Delivered" },
];

export function statusLabel(key) {
  const extra = {
    pending_payment: "Awaiting Payment", fulfillment_error: "Fulfillment Error",
    refund_pending: "Refund Pending", partially_refunded: "Partially Refunded", refunded: "Refunded",
  };
  const map = { ...extra, ...Object.fromEntries(STEPS.map((s) => [s.key, s.label])) };
  return map[key] || key;
}

export default function StatusTracker({ status }) {
  const idx = STEPS.findIndex((s) => s.key === status);
  return (
    <div data-testid="order-status-stepper" className="space-y-0">
      {STEPS.map((s, i) => {
        const done = idx >= 0 && i < idx;
        const active = i === idx;
        return (
          <div key={s.key} className="flex items-start gap-3">
            <div className="flex flex-col items-center">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold shrink-0 transition-colors
                ${done ? "bg-sage text-white" : active ? "bg-amber text-white ring-4 ring-amber/20" : "bg-slate-100 text-slate-400"}`}>
                {done ? <Check className="w-4 h-4" /> : i + 1}
              </div>
              {i < STEPS.length - 1 && <div className={`w-0.5 h-8 ${done ? "bg-sage" : "bg-slate-200"}`} />}
            </div>
            <div className="pt-1">
              <p className={`text-sm font-semibold ${active ? "text-amber" : done ? "text-slateink" : "text-slate-400"}`}>{s.label}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
